class Type {

	public static HOT = new Type(1, "Hot");
	public static WARM = new Type(2, "Warm");
	public static COLD = new Type(3, "Future");

	private constructor(
			public readonly value: 1 | 2 | 3,
			public readonly label: string,
	) {}

	public get hot() {
			return this === Type.HOT;
	}

	public get warm() {
			return this === Type.WARM;
	}

	public get cold() {
			return this === Type.COLD;
	}

	public static leadReadinessValues(): Type[] {
			return [Type.HOT, Type.WARM, Type.COLD];
	}

	public static getById(id: number) {
			return this.leadReadinessValues().find(type => type.value === id);
	}

}

export { Type as LeadReadiness };